import { render } from "./kgo.vue?vue&type=template&id=a579c15c&scoped=true"
import script from "./kgo.vue?vue&type=script&lang=js"
export * from "./kgo.vue?vue&type=script&lang=js"

import "./kgo.vue?vue&type=style&index=0&id=a579c15c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a579c15c"]])

export default __exports__